/** @module csi/table/FilmStripFindController */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/xml"
], function(declare,Controller,xml) {

	return declare(Controller, {
		/**
		 * @override
		 * Set view query to test for given text
		 */
		_onAction: function() {
			this.widget.set("filmstripSearchText", this.actionValue);
			this.widget.set("batchGroups", []);
		},

		/**
		 * @override
		 * Redraw view
		 */
		postProcessSuccess: function() {
			return this.widget.redrawData();
		}
	});
});